import { PersonaSize } from '../components/Persona.Props';

interface PersonaSizeStyle {
    rootIsTiny: string;
    rootIsExtraExtraSmall: string;
    rootIsSmall: string;
    rootIsExtraSmall: string;
    rootIsLarge: string;
    rootIsExtraLarge: string;
    rootIs28: string;
    rootIsSmallPlus: string;
    rootIsRegularPlus: string;
}

const getPersonaSizeClass = (styles: PersonaSizeStyle) => ({
    [PersonaSize.tiny]: 'ms-Persona--tiny ' + styles.rootIsTiny,
    [PersonaSize.extraExtraSmall]: 'ms-Persona--xxs ' + styles.rootIsExtraExtraSmall,
    [PersonaSize.extraSmall]: 'ms-Persona--xs ' + styles.rootIsExtraSmall,
    [PersonaSize.small]: 'ms-Persona--sm ' + styles.rootIsSmall,
    [PersonaSize.regular]: '',
    [PersonaSize.regularPlus]: 'ms-Persona--rp ' + styles.rootIsRegularPlus,
    [PersonaSize.large]: 'ms-Persona--lg ' + styles.rootIsLarge,
    [PersonaSize.extraLarge]: 'ms-Persona--xl ' + styles.rootIsExtraLarge,
    [PersonaSize.size28]: 'ms-Persona--28 ' + styles.rootIs28,
    [PersonaSize.smallPlus]: 'ms-Persona--smp ' + styles.rootIsSmallPlus,
});

export default getPersonaSizeClass;
